/**
 * The permission names, which are the same strings the server's own catalogue holds.
 *
 * <p>Not a guess and not a parallel list to be kept in step by hand: these are the values
 * Denetim.Domain.Access.Permissions defines, they travel in the token as `perm` claims, and
 * every endpoint group names one of them. A typo here hides a menu item; it cannot open a
 * door, because the API asks the same question of the same string.</p>
 */
export const Permission = {
  ManageDefinitions: 'definitions.manage',
  ManageOrganisation: 'organisation.manage',
  ManageTemplates: 'templates.manage',
  ManagePlans: 'plans.manage',
  ManageUsers: 'users.manage',
  ConductAudits: 'audits.conduct',
  ReadAudits: 'audits.read',
  RespondToActions: 'actions.respond',
  ApproveActions: 'actions.approve',
} as const;

export type PermissionName = (typeof Permission)[keyof typeof Permission];
